export default "__VITE_ASSET__9b90ea02__"